import { useEffect, useState } from "react";
import { Organization } from "../Entities/Organization";
import organizationService from "../Service/organization.service";
import AuthService from "../Service/auth.service";

const useOrganization = () => {
  const [org, setOrg] = useState<Organization | null>(null);
  const authService = AuthService.getInstance();

  useEffect(() => {
    const fetchOrgData = async () => {
      const userToken = authService.getAccessTokenFromLocalStorage();
      if (userToken) {
        const orgData = await organizationService.getOrganizationData();
        setOrg(orgData);
      } else {
        setOrg(null);
      }
    };

    fetchOrgData();

    const handleSignIn = () => fetchOrgData();
    authService.subscribe(AuthService.EVENTS.USER_SIGNED_IN, handleSignIn);

    const handleSignOut = () => setOrg(null);
    authService.subscribe(AuthService.EVENTS.USER_SIGNED_OUT, handleSignOut);

    const handleOrgUpdate = (updatedOrg: Organization) => {
      setOrg(updatedOrg);
    };
    organizationService.subscribe("ORGANIZATION_UPDATED", handleOrgUpdate);

    return () => {
      authService.unsubscribe(AuthService.EVENTS.USER_SIGNED_IN, handleSignIn);
      authService.unsubscribe(
        AuthService.EVENTS.USER_SIGNED_OUT,
        handleSignOut
      );
      organizationService.unsubscribe("ORGANIZATION_UPDATED", handleOrgUpdate);
    };
  }, [authService]);

  return {
    org,
    setOrg,
  };
};

export default useOrganization;
